import { makeAutoObservable, runInAction } from 'mobx';
import { RolesPermissionsService } from './service';

interface IRolesPermissions {
  id: string;
  name: string;
  frontendId?: string;
  mode?: number;
}

class RolesPermissions {
  rolesPermissions: {
    [key: string]: {
      data: IRolesPermissions[];
      title: string;
      selectedId: string;
      isLoading: boolean;
    };
  } = {};
  selectedRoleId: string = '';
  timeCalculate: {
    [key: string]: {
      data: {
        data: IRolesPermissions[];
        title: string;
      };
      selectedId: string;
      time: number;
    };
  } = {};

  constructor() {
    makeAutoObservable(this);
  }

  getRolesPermissionsDetails = async (
    payload: {
      roleId: string;
      id: string;
      title: string;
    },
    source: any,
    itemId?: string,
    currentTitle?: string,
    _index?: number,
  ) => {
    try {
      if (this.rolesPermissions[`${currentTitle}`]) {
        this.rolesPermissions[`${currentTitle}`] = {
          ...this.rolesPermissions[`${currentTitle}`],
          isLoading: true,
        };
      }

      if (payload.id) {
        this.timeCalculate[`${payload.id}`] = {
          ...this.timeCalculate[`${payload.id}`],
          selectedId: payload.id || payload.roleId,
          time: Date.now(),
        };
      }

      let result = await RolesPermissionsService.rolesPermissionsDetailsGET(
        payload,
        source,
        itemId || '',
      );

      runInAction(() => {
        let data = result.data;
        delete source.current[`${itemId}`];

        if (payload.id)
          this.timeCalculate[`${payload.id}`] = {
            ...this.timeCalculate[`${payload.id}`],
            data,
          };

        if (Object.keys(source?.current || {}).length === 0) {
          let arr = Object.values(this.timeCalculate || {});
          let largest = arr?.[0] || [];

          for (let i = 0; i < arr.length; i++) {
            if (largest.time < arr[i].time) {
              largest = arr[i];
            }
          }

          // state update
          if (largest?.data) {
            this.rolesPermissions[`${largest.data.title}`] = {
              data: largest.data.data,
              title: largest.data.title,
              selectedId: payload.id || payload.roleId,
              isLoading: false,
            };
          } else if (data) {
            this.rolesPermissions[`${data.title}`] = {
              data: data.data,
              title: data.title,
              selectedId: payload.id || payload.roleId,
              isLoading: false,
            };
          }

          // loading controller
          if (this.rolesPermissions[`${currentTitle}`]) {
            this.rolesPermissions[`${currentTitle}`] = {
              ...this.rolesPermissions[`${currentTitle}`],
              isLoading: false,
            };
          }

          this.timeCalculate = {};
        }
      });
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  updateMode = async (payload: {
    frontEndId: string;
    roleId: string;
    mode: number;
  }) => {
    try {
      await RolesPermissionsService.updateMode(payload);
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  createNewRole = async (params: { roleName: string }) => {
    try {
      let result = await RolesPermissionsService.createNewRolePOST(params);
      return result.data;
    } catch (error) {
      return error;
    }
  };

  cloneRole = async (params: { roleName: string; roleId: string }) => {
    try {
      let result = await RolesPermissionsService.cloneRolePOST(params);
      return result.data;
    } catch (error) {
      return error;
    }
  };
}

export default RolesPermissions;
